export const COMPUTED_SUBSTITUTIONS: string = "Computed Substitutions";
export const PROMOTE: string = "Promote";
export const YES: string = "Yes";
export const CANCEL: string = "Cancel";
export const GENERATE: string = "Generate";
export const COMMEND: string = "Commend";
export const MERCHANT_SETTINGS: string = "Merchant Settings";
export const EMPTY_LOGS_MESSAGE: string = "Click on Generate to get the latest model for promotion";
export const ARS_GENERATION_SUCCESS: string = "ARS generation started ...";
export const NO_LOGS_FOUND: string = 'Logs not found';
export const LOGS: string = 'ARS Logs';
export const ARS_GENERATE_MESSAGE: string = "ARS Generation will now start and may take a couple of hours.";
export const PROCEED: string = "Would you like to proceed?";
export const CONFIRM_MESSAGE: string = "Confirm ARS Generate";
export const COPY: string = "Copy";
export const STATUS: string = "Status";
export const APPLET: string = "Applet";
export const CREATED: string = "Created";
export const UPDATED_BY: string = "Updated by";
export const LAST_UPDATED: string = "Last Updated";
export const SHOW_ONLY_OVERRIDDEN: string = "Show only overridden";
export const SHOW_ONLY_OVERRIDDEN_MESSAGE: string = "Overridden categories are those already assigned to other submodels. These categories cannot be modified here as they are actively managed in another submodel.";
export const SET_MODES_PRIORITY_STRING: string = "Set Modes Priority"
export const TITLE: string = "Title"
export const MIN_NUM_PRODUCTS: string = "minNumProducts"
export const DEFAULT_SUBMODEL: string = "Default Submodel"
export const CATEGORIES: string = "Categories"
export const BASE_CATEGORIES: string = "Base Categories"
export const TARGET_CATEGORIES: string = "Target Categories"
export const SELECTED_CATEGORIES: string = "Selected Categories"
export const SELECT_CATEGORIES: string = "Select Categories"
export const ALL_CATEGORIES: string = "All Categories"
export const NO_CATEGORY_FOUND_SEARCH_MESSAGE: string = "No category found matching your search"
export const NO_CATEGORIES_AVAILABLE_MESSAGE: string = "No categories available"
export const SORRY: string = "Sorry!"
export const VIEW_LESS: string = "View Less"
export const VIEW_MORE: string = "View More"
export const LIVE: string = 'Live';
export const YES_PROCEED: string = 'Yes, Proceed';
export const DRAFT: string = 'Draft';
export const GENERATE_MODEL: string = 'Generate Model';
export const MODEL_TO_GENERATE: string = 'Selected model to generate';
export const GENERATE_MESSAGE: string = 'ARS Generation may take a couple of hours. Would you like to proceed?';
export const PROMOTE_MODEL: string = 'Promote Model';
export const MODELS_TO_PROMOTE: string = 'Selected model(s) to promote';
export const PROMOTE_MESSAGE: string = 'The selected models will be promoted to the ARS service. Would you like to proceed?';
export const CREATE: string = 'Create Model';
export const RECOMMENDER_CREATE: string = "recommender_create";
export const RECOMMENDER_UPLOAD: string = "recommender_upload";
export const RECOMMENDER_READ: string = "recommender_read";
export const RECOMMENDER_UPDATE: string = "recommender_update";
export const RECOMMENDER_DELETE: string = "recommender_delete";
export const RECOMMENDER_GENERATE: string = "recommender_generate";
export const RECOMMENDER_PROMOTE: string = "recommender_promote";
export const INVOICE_PERIOD_FOR_HISTORICAL_DATA: string = "Invoice Period for historical data";
export const SELECT_PERIOD: string = "Select Period";
export const SELECT_MONTH: string = "Select Month";
export const GENERATION_STATUS = "Generation Status";
export const PROMOTION_STATUS = "Promotion Status";
export const GUIDE_MODEL = "Guide Model";

// tooltip messages
export const RECONFIGURED_WARNING_TOOLTIP =
    "Configuration updated after generation. Regenerate the model to reflect the changes.";
export const REGENERATED_WARNING_TOOLTIP =
"The model was regenerated after its last promotion. Promote again to deploy the updated version.";
export const VALIDATION_FAILED_TOOLTIP = "Validation failed"

export const hotSellerInvoicePeriods = [
    'Last 3 Months',
    'Last 6 Months',
    'Last 9 Months',
    'Last 12 Months',
    'All',
    'Custom Date'
] as const;

export const seasonalPeriods = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December', 'Custom Date'
] as const;

export const seasonalYearSpans = ["Last 1 Year", "Last 2 Year", "Last 3 Year", "Last 4 Year", "Last 5 Year", "Last 6 Year", "All Years"] as const;

export const SET_MODES_PRIORITY_OBJECT: any = {
    basic_coseller: {
        title: "Basic Co-Seller",
        description: "Co-selling products, based on order data only",
    },
    compatible_coseller: {
        title: "Compatible Co-Seller",
        description: "Basic co-sellers, filtered further by compatibility rules",
    },
    hot_seller: {
        title: "Hot Seller",
        description: "Products based on popularity",
    },
    computed_substitution: {
        title: "Computed Substitution",
        description: "Substituting products",
    },
    seasonal: {
        title: "Seasonal",
        description:
            "Products based on time series analysis of order data over multiple time periods in a year",
    },
    expert_curated_coseller: {
        title: "Expert Curated Co-Seller",
        description:
            "Basic co-sellers, filtered further by category relevancy set by an SME",
    },
    featured_items: {
        title: "Featured Items",
        description:
            "Top-selling products selected from Top N high-performing categories, used to provide diverse recommendations as a fallback option",
    },
    stipulated_substitution: {
        title: "Stipulated Substitution",
        description:
            "Substitute products manually configured by the merchant and sent using the Substitutes feed",
    },
    basic_substitution: {
        title: "Basic Substitution",
        description:
            "Automatically recommends products with the most matching attribute values.",
    },
    stipulated_co_seller: {
        title: "Stipulated Co-Seller",
        description:
            "Co-selling products manually configured by the merchant and sent using the Related Products feed",
    },
    pure_compatibility: {
        title: "Pure Compatibility",
        description:
            "Compatible products determined exclusively by compatibility rules, without using any order or quote data",
    },
};

export const MODE_SELECTION_OPTIONS = [
    { value: 'combine', label: 'Combine' },
    { value: 'individual', label: 'Individual' }
] as const;

export const DEFAULT_PRIMARY_MODE_TITLE = 'Recommended';
export const DEFAULT_FALLBACK_MODE_TITLE = 'You may also like';
export const DEFAULT_SECTION_MIN_PRODUCT = 50;
export const DEFAULT_MODE_MIN_PRODUCT = 5;

export const PRIMARY_MODE_TYPES = [
    // Co-seller primary modes
    'stipulated_co_seller',
    'expert_curated_coseller',
    'compatible_coseller',
    'pure_compatibility',
    'basic_coseller',
    // Substitution primary modes
    'stipulated_substitution',
    'computed_substitution',
    'basic_substitution'
] as const;

export const FALLBACK_MODE_TYPES = [
    'hot_seller',
    'seasonal',
    'featured_items'
] as const;

export const MODES_WITH_SETTINGS = [
    'compatible_coseller',
    'pure_compatibility',
    'hot_seller',
    'seasonal',
    'expert_curated_coseller'
] as const;

export const SELECT_MODE_LABEL = 'Select Mode';
export const PRIMARY_MODES_LABEL = 'Primary Modes';
export const FALLBACK_MODES_LABEL = 'Fallback Modes';
export const TITLE_LABEL = 'Title';
export const MIN_PRODUCT_LABEL = 'Min Product';